/**
 * Date-extensions locale Breton [br]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('br', {
    monthNames: ['Genver', 'C\'hwevrer', 'Meurzh', 'Ebrel', 'Mae', 'Mezheven', 'Gouere', 'Eost', 'Gwengolo', 'Here', 'Du', 'Kerzu'],
    monthShortNames: ['Gen', 'C\'hwe', 'Meu', 'Ebr', 'Mae', 'Eve', 'Gou', 'Eos', 'Gwe', 'Her', 'Du', 'Ker'],
    dayNames: ['Sul', 'Lun', 'Meurzh', 'Merc\'her', 'Yaou', 'Gwener', 'Sadorn'],
    dayShortNames: ['Sul', 'Lun', 'Meu', 'Mer', 'Yao', 'Gwe', 'Sad']
});
